/**
 * Token storage for Electron (Bearer auth).
 * Cookies don't work from file:// origin, so we use localStorage + Authorization header.
 */

const KEY = 'netmonitor_auth_token';

export function getAuthToken(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setAuthToken(token: string): void {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    // ignore
  }
}

export function clearAuthToken(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}

export function isElectron(): boolean {
  if (typeof window === 'undefined') return false;
  const p = window.location.protocol;
  const ua = navigator.userAgent.toLowerCase();
  return p === 'file:' || p === 'app:' || ua.includes('electron');
}
